import { css, StyleSheet } from 'aphrodite';
import { IVolunteerShift } from '../../../../../../queries/Volunteer';
import { formatShiftTimeRange, groupShiftsByDay } from '../../../../../pages/Volunteers/shiftScheduling';
import { THEME } from '../../../../../components-v2/Theme/theme';

const styles = StyleSheet.create({
	container: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.sm,
		color: THEME.colors.text.light,
	},
	hint: {
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.sm,
	},
	dayLabel: {
		fontWeight: THEME.typography.fontWeights.bold,
		fontSize: THEME.typography.fontSizes.sm,
		color: THEME.colors.text.main,
		marginBottom: THEME.spacing.xs,
	},
	shiftItem: {
		fontSize: THEME.typography.fontSizes.sm,
		color: THEME.colors.text.light,
		paddingLeft: THEME.spacing.sm,
	},
	dayGroup: {
		display: 'flex',
		flexDirection: 'column',
	},
});

export const VolunteerShiftPickerPreview = ({ shifts, timezone }: { shifts: IVolunteerShift[]; timezone?: string }) => {
	const groups = groupShiftsByDay(shifts, timezone);
	if (!groups.length) {
		return <div className={css(styles.hint)}>No shifts yet — add shifts above to preview the volunteer picker.</div>;
	}
	return (
		<div aria-disabled className={css(styles.container)}>
			{groups.map(group => (
				<div key={group.dayKey} className={css(styles.dayGroup)}>
					<div className={css(styles.dayLabel)}>{group.dayLabel}</div>
					{group.shifts.map(shift => (
						<div key={shift.id} className={css(styles.shiftItem)}>
							{formatShiftTimeRange(shift, timezone)}
						</div>
					))}
				</div>
			))}
		</div>
	);
};
